"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ENCRYPTION_TYPE = exports.ENV = void 0;
var ENV;
(function (ENV) {
    ENV["PROD"] = "prod";
    ENV["STAGING"] = "staging";
    ENV["DEV"] = "dev";
    /**
     * **This is for local development only**
     */
    ENV["LOCAL"] = "local";
})(ENV = exports.ENV || (exports.ENV = {}));
var ENCRYPTION_TYPE;
(function (ENCRYPTION_TYPE) {
    ENCRYPTION_TYPE["PGP_V1"] = "x25519-xsalsa20-poly1305";
    ENCRYPTION_TYPE["PGP_V2"] = "aes256GcmHkdfSha256";
    ENCRYPTION_TYPE["PGP_V3"] = "eip191-aes256-gcm-hkdf-sha256";
    ENCRYPTION_TYPE["NFTPGP_V1"] = "pgpv1:nft";
})(ENCRYPTION_TYPE = exports.ENCRYPTION_TYPE || (exports.ENCRYPTION_TYPE = {}));
const Constants = {
    ENV,
    ENCRYPTION_TYPE,
    PAGINATION: {
        INITIAL_PAGE: 1,
        LIMIT: 10,
        LIMIT_MIN: 1,
        LIMIT_MAX: 50,
    },
    DEFAULT_CHAIN_ID: 5,
    DEV_CHAIN_ID: 99999,
    NON_ETH_CHAINS: [137, 80001, 56, 97, 10, 420, 1442, 1101],
    ETH_CHAINS: [1, 5],
    ENC_TYPE_V1: 'x25519-xsalsa20-poly1305',
    ENC_TYPE_V2: 'aes256GcmHkdfSha256',
    ENC_TYPE_V3: 'eip191-aes256-gcm-hkdf-sha256',
    ENC_TYPE_V4: 'pgpv1:nft',
};
exports.default = Constants;
//# sourceMappingURL=constants.js.map